import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Metrics from 'src/entities/Metrics';
import { getMetrics, GetMetricsAction } from 'src/actions/metrics/get/GetMetrics.actions';
import MetricsComponent from 'src/modules/home/partials/Metrics.component';

interface StateProps {
  metrics?: Metrics;
}

interface DispatchProps {
  getMetrics: () => Promise<GetMetricsAction>;
}

interface Props extends StateProps, DispatchProps {
}

class MetricsContainer extends React.Component<Props> {

  public componentWillMount(): void {
    this.props.getMetrics();
  }

  public render(): React.ReactNode {
    return (
      this.props.metrics ?
        <MetricsComponent metrics={this.props.metrics}/> :
        null
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getMetrics: (): Promise<GetMetricsAction> => (
    dispatch(getMetrics())
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  metrics: state.getMetrics.metrics
});

export default connect(mapStateToProps, mapDispatchToProps)(MetricsContainer);


// WEBPACK FOOTER //
// ./src/modules/home/partials/Metrics.container.tsx